module.exports = __webpack_public_path__ + "static/SZITCH-b1d78fd6a65c0b5c28eaa86adad09d1a.jpeg";